import React from 'react';
export function Footer() {
  return <footer className="w-full bg-brand-bg px-6 py-8 text-center" data-id="element-92">
      {/* Separator */}
      <div className="h-px w-full max-w-2xl mx-auto mb-8" style={{
      background: 'linear-gradient(to right, #FF006E, #00F5D4)'
    }} data-id="element-93" />

      <p className="text-white font-semibold text-base mb-4" data-id="element-94">
        Biología Femenina · Método pH-ZERO
      </p>

      <div className="flex items-center justify-center gap-3 text-brand-muted text-sm mb-6" data-id="element-95">
        <a href="#" className="hover:text-white transition-colors" data-id="element-96">
          Política de privacidad
        </a>
        <span data-id="element-97">·</span>
        <a href="#" className="hover:text-white transition-colors" data-id="element-98">
          Términos y condiciones
        </a>
      </div>

      <p className="text-brand-muted text-sm mb-4" data-id="element-99">
        Contacto:{' '}
        <a href="https://instagram.com/biologiafemenina" target="_blank" rel="noopener noreferrer" className="text-brand-teal hover:underline" data-id="element-100">
          @biologiafemenina
        </a>
      </p>

      <div className="max-w-lg mx-auto mb-6" data-id="element-101">
        <p className="text-[12px] text-brand-muted/70 leading-relaxed" data-id="element-102">
          ⚕️ Este producto es de carácter informativo y educativo. No constituye
          consejo médico ni reemplaza la consulta con un profesional de la
          salud. Los resultados pueden variar.
        </p>
      </div>

      <p className="text-[12px] text-brand-muted/50" data-id="element-103">
        © 2024 Biología Femenina · Argentina
      </p>
    </footer>;
}